/**
 * 公用配置类
 * @type {{baseURL: string}}
 */
const global = {
// 正式环境 https://sc.tdcheck.cn
// 开发环境 http://121.37.169.233:8083
// 俊成开发环境 http://192.168.2.199:8083
  // baseURL: 'https://sc.tdcheck.cn/',
  maoUrl: '/dist/',
  maoUrl: ''
};
export default global



// WEBPACK FOOTER //
// ./src/utils/global.js